module.exports = __webpack_public_path__ + "assets/27ad31261801aa15241fa4ea8a0c8777.png";